/** Total numbers in Tambola (1 to 90) */
export const TAMBOLA_MAX_NUMBER = 90;
/** Minimum number in Tambola */
export const TAMBOLA_MIN_NUMBER = 1;
/** Number of rows in a ticket */
export const TICKET_ROWS = 3;
/** Number of columns in a ticket */
export const TICKET_COLS = 9;
/** Numbers per row in a ticket */
export const NUMBERS_PER_ROW = 5;
/** Blanks per row in a ticket */
export const BLANKS_PER_ROW = 4;
/** Default call interval in seconds */
export const DEFAULT_CALL_INTERVAL = 5;
/** Maximum players per room */
export const MAX_PLAYERS_PER_ROOM = 100;
/** Maximum tickets per player */
export const MAX_TICKETS_PER_PLAYER = 6;
/** Minimum players to start a game */
export const MIN_PLAYERS_TO_START = 2;
/** Room code length */
export const ROOM_CODE_LENGTH = 6;
//# sourceMappingURL=game.constants.js.map